import { query, watchQuery } from '../../network/fetch'
import axios from '../../network/axios'
import { get } from '../../utilities'
import { bugsnagClient } from '../../utilities/bugsnag'
import { getMe } from '../../network/queries/users'
import Sockets from '../../utilities/sockets'
import moment from 'moment'
import Task from '../models/Task'
import UserTile from '../models/UserTile'

var echo = null

import {
    LOGIN,
    LOGOUT,
    USER_SET_CURRENT,
    USER_REMOVE_CURRENT,
    USER_SET_SEARCH_TOKEN,
    USER_TASK_LIST,
    USER_TILE_LIST
} from '../types'

const graph = {
    switchSchool: `mutation SwitchSchool($schoolId: Int!) {
        switchSchool(school_id: $schoolId) {
            id
            search_token
            school_id
        }
    }`
}

// initial state
const state = {
    current: null,
    token: localStorage.getItem('token'),
    searchToken: localStorage.getItem('searchToken'),
    isLoggedIn: !!localStorage.getItem('token')
}

const getters = {
    user: state => state.current,
    fullName: state => {
        return get(state, 'current.first_name', '')
            + ' '
            + get(state, 'current.last_name', '')
    },
    role: state => get(state, 'current.role.id', Number.MAX_VALUE),
    roleName: state => get(state, 'current.role.display_name'),
    isLoggedIn: state => state.isLoggedIn,
    assignedTeams: state => {
        return get(state, 'current.assignedTeams') || []
    },
    hasUser: state => !!state.current,
    inTz: (state) => (date) => {
        return moment(date + ' UTC', 'YYYY-MM-DD HH:mm:ss z')
            .tz(get(state, 'current.school.timezone', 'UTC'))
            .toDate()
    },
    needsHigherContrast: state => get(state, 'current.higher_contrast', 0),
    a11yMode: state => get(state, 'current.a11y_mode', 0),
}

const actions = {
    login ({ commit, dispatch }, creds) {
        return new Promise((resolve, reject) => {
            axios
                .post('/api/v2/login', creds)
                .then( ({ data }) => {
                    commit('USER_SET_CURRENT', data.data.user)
                    commit('LOGIN', {
                        token: data.data.access_token,
                        searchToken: data.data.search_token
                    })
                    dispatch('getCurrentUser')
                    resolve()
                }, ({ response }) => {
                    if (response.data) {
                        reject(response.data)
                    }
                    else {
                        reject('Incorrect email or password combination. Please try again.')
                    }
                })
        })
    },

    logout ({ commit }) {
        return new Promise((resolve) => {
            commit(LOGOUT)
            resolve()
        })
    },

    watchCurrentUser ({ commit, state }) {

        /// If no token, dont even try to get user
        if (!state.token) return

        watchQuery({
            query: getMe,
            pollInterval: 90000
        }, ({ data }) => {

            /// Let's compare versions and reload if needed
            // if (headers['x-spotter-version'] != window.App.version) {
            //     location.reload(true)
            // }

            commit(USER_SET_CURRENT, data.me)
        }, ({ response }) => {
            if (get(response, 'status', 200) == 401) {
                commit('LOGOUT')
            }
        })
    },

    getCurrentUser ({ commit }) {
        return new Promise((resolve, reject) => {
            query({ query: getMe })
                .then( ({ data }) => {
                    commit(USER_SET_CURRENT, data.me)
                    commit(USER_TASK_LIST, data.me.tasks)
                    resolve()
                }, ({ response }) => {
                    if (get(response, 'status', 200) == 401) {
                        commit('LOGOUT')
                    }
                    reject(response)
                });
        })
    },

    checkUserLoad ({ state, dispatch }) {
        return state.current ? new Promise((resolve) => { resolve() }) : dispatch('getCurrentUser')
    },

    checkInviteCode (_, code) {
        return new Promise((resolve, reject) => {
            axios
                .post('/api/v2/checkInvitation', { token: code })
                .then( () => {
                    resolve(true)
                }, ({ response }) => {
                    reject(response.data)
                })
        })
    },

    register (_, user) {
        return new Promise((resolve, reject) => {
            axios
                .post('/api/v2/register', user)
                .then( ({ data }) => {
                    resolve(data)
                }, ({ response }) => {
                    reject(response.data)
                })
        })
    },

    switchSchool ({ commit }, params) {

        return new Promise((resolve) => {
            query({
                query: graph.switchSchool,
                variables: params
            }).then( ({ data }) => {
                commit(USER_SET_SEARCH_TOKEN, data.switchSchool.search_token)
                resolve()
            })
        })
    },

    forgotPassword (_, creds) {
        return new Promise((resolve, reject) => {
            axios
                .post('/api/v2/password/forgot', creds)
                .then( () => {
                    resolve()
                }, ({ response }) => {
                    reject(response.data)
                })
        })
    },

    resetPassword (_, creds) {
        return new Promise((resolve, reject) => {
            axios
                .post('/api/v2/password/reset', creds)
                .then( ({ data }) => {
                    resolve(data)
                }, ({ response }) => {
                    reject(response.data)
                })
        })
    }
}

// mutations
const mutations = {
    [LOGIN] (state, tokens) {
        state.isLoggedIn = true
        state.token = tokens.token
        state.searchToken = tokens.searchToken

        // Store token as well as set it for axios use
        localStorage.setItem('token', tokens.token)
        localStorage.setItem('searchToken', tokens.searchToken)
    },

    [LOGOUT] (state) {
        state.isLoggedIn = false
        state.token = null
        state.current = null

        // Remove local store
        localStorage.removeItem('token')
        localStorage.removeItem('searchToken')

        window.location = '/Login'
    },
    [USER_SET_SEARCH_TOKEN] (state, searchToken) {
        state.searchToken = searchToken
        localStorage.setItem('searchToken', searchToken)
    },
    [USER_SET_CURRENT] (state, user) {
        state.current = user

        /// Establish the user with Bugsnag
        if (user) {
            bugsnagClient.user = {
                id: user.id,
                email: user.email
            }
            if (!echo) {
                echo = new Sockets(state.token)
            }
            echo.listen(user)

            window.Beacon('identify', {
                name: user.first_name + ' ' + user.last_name,
                email: user.email
            })
        }
    },
    [USER_REMOVE_CURRENT] (state) { state.current = null },
    [USER_TASK_LIST] (_, tasks) {
        Task.insertOrUpdate({ data: tasks })
    },
    [USER_TILE_LIST] (_, tiles) {
        UserTile.insertOrUpdate({ data: tiles })
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}
